import { _ } from "libs";

import React from "react";
import withRedux from "../../withRedux";
import Modal from "../modal";
import {
	closeOfficialRatingPopup,
	closePlayerPopup,
	getOfficialRating,
	openOfficialRatingPopup,
	openPlayerPopup,
} from "../../actions";
import { RootState } from "../../reducers";
import OfficialRatingProfile from "../officialRatingProfile";

function OfficialRatingModal({
	show = false,
	userId = null,
	federation = null,
	federationName = null,
}: {
	show: boolean;
	userId: string;
	federation: string;
	federationName: string;
}) {
	if (show === false) {
		return null;
	}

	const close = () => {
		closeOfficialRatingPopup();
	};

	const onBackClicked = (event) => {
		openPlayerPopup(userId);
		closeOfficialRatingPopup();
	};

	if (userId === null || federation === null) {
		return (
			<Modal title={_("error.ratingNotFound")} onCloseClicked={close}>
				{_("error.ratingNotFound")}
			</Modal>
		);
	}

	return (
		<Modal title={""} onCloseClicked={close} className={`headerImage ${federation}`} onBackClicked={onBackClicked}>
			<OfficialRatingProfile
				federation={federation}
				userId={userId}
				federationName={federationName}
				onClose={null}
			/>
		</Modal>
	);
}

function mapStateToProps({ playerRatingModal: { show, userId, federation, federationName } }: RootState) {
	return { show, userId, federation, federationName };
}

export default withRedux({}, mapStateToProps)(OfficialRatingModal);
